import { connect } from 'react-redux';
import { Url } from 'utils/url';

import { sendPopupData, getFeedbackOptions } from '../actions/feedbackPopup';

import FeedbackForm from '../components/FeedbackForm';

const handleFormSubmit = (formData) => {
  const { location } = window;
  const { feedbackComments, issueType } = formData;

  return sendPopupData({
    issueType: Number(issueType),
    comments: feedbackComments,
    pageUrl: new Url(`${location.pathname}${location.search}`).toString(),
  });
};

export default connect(
  (state) => ({
    feedbackOptions: state.feedbackPopup.feedbackOptions,
    hasError: state.feedbackPopup.hasError,
  }), {
    handleFormSubmit,
    getFeedbackOptions,
  }
)(FeedbackForm);
